const transactionStatuses = [
    {id: 'completed',name: 'completed'},
    {id: 'pending',name: 'pending'},
    {id: 'declined',name: 'declined'},
    {id: 'canceled',name: 'canceled'},
    {id: 'reversed',name: 'reversed'},
];

export default transactionStatuses;
